import utils from '../libs/utils';
import axios from './axios';

const protocol = window.location.protocol;
const baseUrl = 'v1/erp-base-web';
const insuranceUrl = `${protocol}//medical.erp.dtp.linkdoc.com:9999`;
const businessUrl = 'v1/erp-business-web';

export default {
  axios,
  signIn() { //签到
    return axios.post(`${insuranceUrl}/medical/sign/in`);
  },
  signOut() { //签退
    return axios.post(`${insuranceUrl}/medical/sign/out`);
  },
  getSignRecords(params) {
    return axios.post(`${businessUrl}/medical/getSignLog`, utils.exchangeParams(params));
  },
  retreat(params) {
    return axios.post(`${baseUrl}/medical/directory/undo`, utils.exchangeParams(params));
  },
  updateDir() {
    return axios.get(`${insuranceUrl}/medical/dire/download`);
  },
  confirmAuto(params) {
    return axios.post(`${businessUrl}/medical/autoMatchDire`, utils.exchangeParams(params));
  },
  getDrugData(params) {
    return axios.post(`${baseUrl}/goods/store/medical/getGoodsRel`, utils.exchangeParams(params));
  },
  confirmConnect(params) { // 目录上传
    return axios.post(`${insuranceUrl}/medical/directory/upload`, utils.exchangeParams(params));
  },
  dirMatch(params) {
    return axios.post(`${businessUrl}/medical/directory/match`, utils.exchangeParams(params));
  },
  deleteDir(params) {
    return axios.post(`${insuranceUrl}/medical/directory/undo`, utils.exchangeParams(params));
  },
  insuranceDrugSearch(params) {
    return axios.post(`${businessUrl}/medical/getDireInfo`, utils.exchangeParams(params));
  },
  getNumberInfo(params) {
    return axios.get(`${businessUrl}/medical/getRelCount?${utils.exchangeParams(params)}`);
  },
  dirUpdate(params) {
    return axios.post(`${insuranceUrl}/medical/directory/update`, utils.exchangeParams(params));
  },
  retreatOrder(params) { //撤销订单
    return axios.post(`${insuranceUrl}/medical/settlement/undo`, utils.exchangeParams(params));
  },
  getOrders(params) {
    return axios.post(`${businessUrl}/medical/getMedicalOrder`, utils.exchangeParams(params));
  },
  checkTotal(params) {
    return axios.post(`${insuranceUrl}/medical/checkTotal`, utils.exchangeParams(params));
  },
  getCheckAccountRecords(params) {
    return axios.post(`${businessUrl}/medical/getAccountCheckLog`, utils.exchangeParams(params));
  },
  checkDetail(params) {
    return axios.post(`${insuranceUrl}/medical/checkDetail`, utils.exchangeParams(params));
  },
  getByRole(params) {
    return axios.get(`/v1/erp-sys-web/sys/user/list/byRole?${utils.exchangeParams(params)}`);
  },
  updateMedListCodg(params) {
    return axios.post(`/v1/erp-sys-web/sys/user/updateMedListCodg?`, utils.exchangeParams(params));
  },
  treatment(params) {
    return axios.post(`${insuranceUrl}/medical/userTreatmentCheck`, utils.exchangeParams(params));
  },
  getUserDiseaseInfo(params) {
    return axios.get(`${insuranceUrl}/medical/getUserOpspDiseInfo?${utils.exchangeParams(params)}`);
  },
  readCard(params) {
    return axios.post(`${insuranceUrl}/medical/readCard`, utils.exchangeParams(params));
  },
  getMedOrgInfos(params) {
    return axios.get(`${insuranceUrl}/medical/getRtalPhacInfo?${utils.exchangeParams(params)}`);
  },
  getMedTypeList() {
    return axios.get(`${businessUrl}/medical/getMedType`);
  },
  getExpenseInfo(params) {
    return axios.post(`${insuranceUrl}/medical/costInfo`, utils.exchangeParams(params));
  },
  getExpenseInfoDetail(params) {
    return axios.post(`${insuranceUrl}/medical/costDetailInfo`, utils.exchangeParams(params));
  },
  getSettlementInfo(params) {
    return axios.post(`${insuranceUrl}/medical/getSettlementSheetInfo`, utils.exchangeParams(params));
  },
  getSettleInfos(params) {
    return axios.post(`${insuranceUrl}/medical/settlementInfos`, utils.exchangeParams(params));
  },
  getDrugInfo(params) {
    return axios.post(`${insuranceUrl}/medical/getMedicalDireInfo`, utils.exchangeParams(params));
  },
  exportOrder(params) {
    return axios.get(`${businessUrl}/medical/exportOrder?${utils.exchangeParams(params)}`);
  },
  pinganfoExportData(params) {
    return axios.get(`${businessUrl}/medical/foshan/exportPingAnFoInfo?${utils.exchangeParams(params)}`);
  },
  getconverRelate(params) {
    return axios.post(`${businessUrl}/medical/getConverRelate`, utils.exchangeParams(params));
  },
  insertGrainDrug(params) {
    return axios.post(`${businessUrl}/medical/insertConverRelate`, utils.exchangeParams(params));
  },
  updateGrainDrug(params) {
    return axios.post(`${businessUrl}/medical/updateConverRelate`, utils.exchangeParams(params));
  },
  download(params) {
    return axios.post(`${insuranceUrl}/medical/medDire/download`, utils.exchangeParams(params), {
      responseType: 'blob',
      timeout: 60000
    });
  },
  commonSearch(params, path) {
    return axios.post(`${insuranceUrl}${path}`, utils.exchangeParams(params));
  },
  recipeList(params) { // 双通道处方列表
    return axios.get(`${businessUrl}/medical/elec/listRx?${utils.exchangeParams(params)}`);
  },
  recipeDetail(params) { // 处方详情
    return axios.post(`${businessUrl}/medical/elec/rxDetail`, utils.exchangeParams(params));
  },
  rxSaleWrif(params) { // 撤销处方
    return axios.post(`${insuranceUrl}/medical/elec/rxSaleWrif`, utils.exchangeParams(params));
  },
  querRx(params) { // 根据患者信息从医保局获得可下载的处方列表
    return axios.post(`${insuranceUrl}/medical/elec/querRx`, utils.exchangeParams(params));
  },
  dowloadRx(params) { // 确认使用了
    return axios.post(`${insuranceUrl}/medical/elec/dowloadRx`, utils.exchangeParams(params));
  },
  rxAudit(params) { // 审核通过
    return axios.post(`${insuranceUrl}/medical/elec/rxAudit`, utils.exchangeParams(params));
  },
  rectification(params) { // 挂起回退
    return axios.post(`${insuranceUrl}/medical/rectification`, utils.exchangeParams(params));
  },
  finishedNotice(params) { // 手动对账
    return axios.post(`${insuranceUrl}/medical/bj/finishedNotice`, utils.exchangeParams(params));
  },
  importUpload(params) { // 进销上传
    return axios.post(`${insuranceUrl}/medical/uploadData`, utils.exchangeParams(params));
  },
  importList(params) { // 进销列表
    return axios.post(`${businessUrl}/medical/listMedJobRecord`, utils.exchangeParams(params));
  },
};
